
@if (showEnableFeature) {
  <div class="row button-container">
    <div class="col-2 custom-button">
      <div class="rSet enable-alo-label">
        <label aria-hidden="true">
          Enable feature
          <input type="checkbox" class="primary-checkbox"  name="enableFeature"
            [(ngModel)]="isEnableFeature" (change)="enableFeatureChanged($event.target.checked)" />
            <span class="extra-border-enablefeat" id="LSI-enable-feature" role="checkbox" aria-checked="false" [attr.aria-checked]="isEnableFeature"></span>
          </label>
        </div>
      </div>
      <div class="col-8"></div>
      <div class="col-1"></div>
    </div>
  }
  <div class="row slider-container mode-margin" [ngClass]="{'isResetDisabled': lsiDisabled && showEnableFeature}">
    <div class="col-1 label signifyBookmd dim-margin" id="LSI-mode-label">Mode</div>
    <div class="col-4 mode-container" style="margin-top: 0.3em;">
      <select id="LSI-mode-dropdown" class="signifyBookmd select-dimming"
        [(ngModel)]="selectedMode" (change)="onModeChange(selectedMode)" [disabled]="lsiDisabled && showEnableFeature">
        @for (mode of modeOptions; track mode; let i = $index) {
          <option [value]="mode" class="info-val" [id]="'LSI-mode-option-' + i">{{ mode }}</option>
        }
      </select>
    </div>
    <div class="col-7"></div>
  </div>
  <div class="row slider-container activedim-margin" [ngClass]="{'isResetDisabled': lsiDisabled && showEnableFeature}">
    <div class="col-1 label signifyBookmd dim-margin zero-margin-top" id="LSI-activedim-label">Active dim level</div>
    @if (quickConfigvalue) {
      <div class="col-2">
        <div class="row">
          <div class="col-4"></div>
          <div class="col-2 minValMargin">
            <span id="LSI-activedim-STDmin" class="signifyBookmd minValue"> min {{activeDimLevelMin}}</span>
          </div>
          <div class="col-3">
            <span id="LSI-activedim-STDmax" class="signifyBookmd maxValue"> max {{activeDimLevelMax}}</span>
          </div>
        </div>
      </div>
    }
    @if (!quickConfigvalue) {
      <span class="signifyBookmd text-mindim  sliderMinValue col-1" id="LSI-activedim-min">{{activeDimLevelMin}}</span>
    }
    @if (!quickConfigvalue) {
      <div class="col-6 curvePadding sliderCss" id="LSI-activedim-slider" [ngClass]="{'isSliderClick': lsiDisabled && showEnableFeature}">
        <ngx-slider type="normalType" id="LSI-activedim-range" ngDefaultControl
          [value]="getSliderSafeValue(activeDimLevel, activeDimLevelMin, activeDimLevelMax)" [options]="activeDimLevelOptions"
          (userChangeEnd)="activeDimLevelChange($event.value)">
        </ngx-slider>
      </div>
    }
    @if (!quickConfigvalue) {
      <span class="signifyBookmd text-mindim col-1 startUpMargin" id="LSI-activedim-max">{{activeDimLevelMax}}</span>
    }
    <div class="row form-group col-3">
      <input type="number" [value]="activeDimLevelDisplayValue" [step]="activeDimAllowDecimal ? 'any' : '1'"
        class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard" id="LSI-activedim-input"
        (input)="onFieldInput($event.target.value, 'activeDim')" (blur)="onFieldBlur($event.target, 'activeDim')" [disabled]="lsiDisabled && showEnableFeature"
        (keypress)="validateKeypress($event, activeDimAllowDecimal)" [ngClass]="{'myStyle': inputError['activeDim']===true, 'isResetDisabled custom-inputbox-disabled': lsiDisabled && showEnableFeature, 'inputCssStandard': quickConfigvalue===true}">
        <p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</p>
      </div>
    </div>
    <div class="row slider-container" [ngClass]="{'isResetDisabled': lsiDisabled && showEnableFeature}">
      <div class="col-1 label signifyBookmd dim-margin zero-margin-top" id="LSI-inactivedim-label">Inactive dim level</div>
      @if (quickConfigvalue) {
        <div class="col-2">
          <div class="row">
            <div class="col-4"></div>
            <div class="col-2 minValMargin">
              <span id="LSI-inactivedim-STDmin" class="signifyBookmd minValue"> min {{inactiveDimLevelMin}}</span>
            </div>
            <div class="col-3">
              <span id="LSI-inactivedim-STDmax" class="signifyBookmd maxValue"> max {{inactiveDimLevelMax}}</span>
            </div>
          </div>
        </div>
      }
      @if (!quickConfigvalue) {
        <span class="signifyBookmd text-mindim  sliderMinValue col-1" id="LSI-inactivedim-min">{{inactiveDimLevelMin}}</span>
      }
      @if (!quickConfigvalue) {
        <div class="col-6 curvePadding sliderCss" id="LSI-inactivedim-slider" [ngClass]="{'isSliderClick': lsiDisabled && showEnableFeature}">
          <ngx-slider type="normalType" id="LSI-inactivedim-range" ngDefaultControl
            [value]="getSliderSafeValue(inactiveDimLevel, inactiveDimLevelMin, inactiveDimLevelMax)" [options]="inactiveDimLevelOptions"
            (userChangeEnd)="inactiveDimLevelChange($event.value)">
          </ngx-slider>
        </div>
      }
      @if (!quickConfigvalue) {
        <span class="signifyBookmd text-mindim col-1 startUpMargin" id="LSI-inactivedim-max">{{inactiveDimLevelMax}}</span>
      }
      <div class="row form-group col-3">
        <input type="number" [value]="inactiveDimLevelDisplayValue" [step]="inactiveDimAllowDecimal ? 'any' : '1'"
          class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard" id="LSI-inactivedim-input"
          (input)="onFieldInput($event.target.value, 'inactiveDim')" (blur)="onFieldBlur($event.target, 'inactiveDim')" [disabled]="lsiDisabled && showEnableFeature"
          (keypress)="validateKeypress($event, inactiveDimAllowDecimal)" [ngClass]="{'myStyle': inputError['inactiveDim']===true, 'isResetDisabled custom-inputbox-disabled': lsiDisabled && showEnableFeature, 'inputCssStandard': quickConfigvalue===true}" />
          <p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</p>
        </div>
      </div>
      <!-- Polarity Section -->
      <div class="row slider-container polarity-section" [ngClass]="{'isResetDisabled': lsiDisabled && showEnableFeature}">
        <div class="col-1 label signifyBookmd dim-margin" id="LSI-polarity-label">Polarity</div>
        <div class="col-11 polarity-options">
          @for (option of polarityOptions; track option; let i = $index) {
            <label class="radio-label" aria-hidden="true">
              <input type="radio" name="polarity" [value]="option" [id]="'LSI-polarity-' + i + '-radio'" class="dimming-radio"
                [(ngModel)]="selectedPolarity" (change)="onPolarityChange(selectedPolarity)" [disabled]="lsiDisabled && showEnableFeature" />
                <span class="signifyBookmd radio-text" [id]="'LSI-polarity-' + i + '-text'">{{ option }}</span>
              </label>
            }
          </div>
        </div>
        <!-- Fade on time -->
        <div class="row slider-container" [ngClass]="{'isResetDisabled': lsiDisabled && showEnableFeature}">
          <div class="col-1 label signifyBookmd dim-margin zero-margin-top" id="LSI-fadeon-label">Fade on time</div>
          @if (quickConfigvalue) {
            <div class="col-2">
              <div class="row">
                <div class="col-4"></div>
                <div class="col-2 minValMargin">
                  <span id="LSI-fadeon-STDmin" class="signifyBookmd minValue"> min {{fadeOnTimeMin}}</span>
                </div>
                <div class="col-3">
                  <span id="LSI-fadeon-STDmax" class="signifyBookmd maxValue"> max {{fadeOnTimeMax}}</span>
                </div>
              </div>
            </div>
          }
          @if (!quickConfigvalue) {
            <span class="signifyBookmd text-mindim  sliderMinValue col-1" id="LSI-fadeon-min">{{fadeOnTimeMin}}</span>
          }
          @if (!quickConfigvalue) {
            <div class="col-6 curvePadding sliderCss" id="LSI-fadeon-slider" [ngClass]="{'isSliderClick': lsiDisabled && showEnableFeature}">
              <ngx-slider type="normalType" id="LSI-fadeon-range" ngDefaultControl
                [value]="getSliderSafeValue(fadeOnTime, fadeOnTimeMin, fadeOnTimeMax)" [options]="fadeOnTimeOptions"
                (userChangeEnd)="fadeOnTimeChange($event.value)">
              </ngx-slider>
            </div>
          }
          @if (!quickConfigvalue) {
            <span class="signifyBookmd text-mindim col-1 startUpMargin" id="LSI-fadeon-max">{{fadeOnTimeMax}}</span>
          }
          <div class="row form-group col-3">
            <input type="number" [value]="fadeOnTimeDisplayValue"
              class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard" id="LSI-fadeon-input"
              (input)="onFieldInput($event.target.value, 'fadeOn')" [disabled]="lsiDisabled && showEnableFeature"
              (keypress)="numberOnly($event)" [ngClass]="{'myStyle': inputError['fadeOn']===true, 'isResetDisabled custom-inputbox-disabled': lsiDisabled && showEnableFeature, 'inputCssStandard': quickConfigvalue===true}">
              <p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">s</p>
            </div>
          </div>
          <!-- Hold off delay -->
          <div class="row slider-container" [ngClass]="{'isResetDisabled': lsiDisabled && showEnableFeature}">
            <div class="col-1 label signifyBookmd dim-margin zero-margin-top" id="LSI-holdoff-label">Hold off delay</div>
            @if (quickConfigvalue) {
              <div class="col-2">
                <div class="row">
                  <div class="col-4"></div>
                  <div class="col-2 minValMargin">
                    <span id="LSI-holdoff-STDmin" class="signifyBookmd minValue"> min {{holdOffDelayMin}}</span>
                  </div>
                  <div class="col-3">
                    <span id="LSI-holdoff-STDmax" class="signifyBookmd maxValue"> max {{holdOffDelayMax}}</span>
                  </div>
                </div>
              </div>
            }
            @if (!quickConfigvalue) {
              <span class="signifyBookmd text-mindim  sliderMinValue col-1" id="LSI-holdoff-min">{{holdOffDelayMin}}</span>
            }
            @if (!quickConfigvalue) {
              <div class="col-6 curvePadding sliderCss" id="LSI-holdoff-slider" [ngClass]="{'isSliderClick': lsiDisabled && showEnableFeature}">
                <ngx-slider type="normalType" id="LSI-holdoff-range" ngDefaultControl
                  [value]="getSliderSafeValue(holdOffDelay, holdOffDelayMin, holdOffDelayMax)" [options]="holdOffDelayOptions"
                  (userChangeEnd)="holdOffDelayChange($event.value)">
                </ngx-slider>
              </div>
            }
            @if (!quickConfigvalue) {
              <span class="signifyBookmd text-mindim col-1 startUpMargin" id="LSI-holdoff-max">{{holdOffDelayMax}}</span>
            }
            <div class="row form-group col-3">
              <input type="number" [value]="holdOffDelayDisplayValue"
                class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard" id="LSI-holdoff-input"
                (input)="onFieldInput($event.target.value, 'holdOff')" [disabled]="lsiDisabled && showEnableFeature"
                (keypress)="numberOnly($event)" [ngClass]="{'myStyle': inputError['holdOff']===true, 'isResetDisabled custom-inputbox-disabled': lsiDisabled && showEnableFeature, 'inputCssStandard': quickConfigvalue===true}">
                <p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">s</p>
              </div>
            </div>
            <!-- Fade off time -->
            <div class="row slider-container" [ngClass]="{'isResetDisabled': lsiDisabled && showEnableFeature}">
              <div class="col-1 label signifyBookmd dim-margin zero-margin-top" id="LSI-fadeoff-label">Fade off time</div>
              @if (quickConfigvalue) {
                <div class="col-2">
                  <div class="row">
                    <div class="col-4"></div>
                    <div class="col-2 minValMargin">
                      <span id="LSI-fadeoff-STDmin" class="signifyBookmd minValue"> min {{fadeOffTimeMin}}</span>
                    </div>
                    <div class="col-3">
                      <span id="LSI-fadeoff-STDmax" class="signifyBookmd maxValue"> max {{fadeOffTimeMax}}</span>
                    </div>
                  </div>
                </div>
              }
              @if (!quickConfigvalue) {
                <span class="signifyBookmd text-mindim  sliderMinValue col-1" id="LSI-fadeoff-min">{{fadeOffTimeMin}}</span>
              }
              @if (!quickConfigvalue) {
                <div class="col-6 curvePadding sliderCss" id="LSI-fadeoff-slider" [ngClass]="{'isSliderClick': lsiDisabled && showEnableFeature}">
                  <ngx-slider type="normalType" id="LSI-fadeoff-range" ngDefaultControl
                    [value]="getSliderSafeValue(fadeOffTime, fadeOffTimeMin, fadeOffTimeMax)" [options]="fadeOffTimeOptions"
                    (userChangeEnd)="fadeOffTimeChange($event.value)">
                  </ngx-slider>
                </div>
              }
              @if (!quickConfigvalue) {
                <span class="signifyBookmd text-mindim col-1 startUpMargin" id="LSI-fadeoff-max">{{fadeOffTimeMax}}</span>
              }
              <div class="row form-group col-3">
                <input type="number" [value]="fadeOffTimeDisplayValue"
                  class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard" id="LSI-fadeoff-input"
                  (input)="onFieldInput($event.target.value, 'fadeOff')" [disabled]="lsiDisabled && showEnableFeature"
                  (keypress)="numberOnly($event)" [ngClass]="{'myStyle': inputError['fadeOff']===true, 'isResetDisabled custom-inputbox-disabled': lsiDisabled && showEnableFeature, 'inputCssStandard': quickConfigvalue===true}">
                  <p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">s</p>
                </div>
              </div>
              <!-- Switch off delay -->
              <div class="row slider-container" [ngClass]="{'isResetDisabled': lsiDisabled && showEnableFeature}">
                <div class="col-1 label signifyBookmd dim-margin zero-margin-top" id="LSI-switchoff-label">Switch off delay</div>
                @if (quickConfigvalue) {
                  <div class="col-2">
                    <div class="row">
                      <div class="col-4"></div>
                      <div class="col-2 minValMargin">
                        <span id="LSI-switchoff-STDmin" class="signifyBookmd minValue"> min {{switchOffDelayMin}}</span>
                      </div>
                      <div class="col-3">
                        <span id="LSI-switchoff-STDmax" class="signifyBookmd maxValue"> max {{switchOffDelayMax}}</span>
                      </div>
                    </div>
                  </div>
                }
                @if (!quickConfigvalue) {
                  <span class="signifyBookmd text-mindim  sliderMinValue col-1" id="LSI-switchoff-min">{{switchOffDelayMin}}</span>
                }
                @if (!quickConfigvalue) {
                  <div class="col-6 curvePadding sliderCss" id="LSI-switchoff-slider" [ngClass]="{'isSliderClick': lsiDisabled && showEnableFeature}">
                    <ngx-slider type="normalType" id="LSI-switchoff-range" ngDefaultControl
                      [value]="getSliderSafeValue(switchOffDelay, switchOffDelayMin, switchOffDelayMax)" [options]="switchOffDelayOptions"
                      (userChangeEnd)="switchOffDelayChange($event.value)">
                    </ngx-slider>
                  </div>
                }
                @if (!quickConfigvalue) {
                  <span class="signifyBookmd text-mindim col-1 startUpMargin" id="LSI-switchoff-max">{{switchOffDelayMax}}</span>
                }
                <div class="row form-group col-3">
                  <input type="number" [value]="switchOffDelayDisplayValue"
                    class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard" id="LSI-switchoff-input"
                    (input)="onFieldInput($event.target.value, 'switchOff')" [disabled]="lsiDisabled && showEnableFeature"
                    (keypress)="numberOnly($event)" [ngClass]="{'myStyle': inputError['switchOff']===true, 'isResetDisabled custom-inputbox-disabled': lsiDisabled && showEnableFeature, 'inputCssStandard': quickConfigvalue===true}">
                    <p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">s</p>
                  </div>
                </div>
                <!-- Enable switch off delay checkbox -->
                <div class="row slider-container" [ngClass]="{'isResetDisabled': lsiDisabled && showEnableFeature}">
                  <div class="col-1"></div>
                  <div class="col-11 enable-switchoff-checkbox">
                    <label class="enable-switchOffDelay-label" aria-hidden="true">
                      <input type="checkbox" class="p-checkbox" id="LSI-enable-switchoff" name="enableSwitchOff"
                        [(ngModel)]="enableSwitchOffDelay" (change)="onEnableSwitchOffDelayChange(enableSwitchOffDelay)" [disabled]="lsiDisabled && showEnableFeature" />
                        <span class="signifyBookmd checkbox-text">Enable switch off delay</span>
                      </label>
                    </div>
                  </div>
                  <br>
